(() => {
  const palette = {
    'baby-blue': '#b8cbea', 'champagne-beige': '#d8cfbc', 'cotton-candy': '#e8b8bf',
    'deep-navy': '#203a60', 'forest-green': '#176b5d', 'midnight-black': '#242526',
    'red-velvet': '#df2034', 'stone-taupe': '#a59f8b', 'sun-brown': '#9b674e',
    'sunset-orange': '#d96b3d', 'wine-burgundy': '#702d3d'
  };

  const slugify = (value) => value.toLocaleLowerCase('tr-TR').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const parseTitle = (title) => {
    const parts = title.split(/\s*[–—-]\s*/).map((part) => part.trim()).filter(Boolean);
    if (parts.length < 2) return null;
    return { model: parts.slice(0, -1).join(' - '), modelKey: parts.slice(0, -1).join(' - ').toLocaleLowerCase('tr-TR'), color: parts.at(-1) };
  };

  const hydrateColors = async (summary) => {
    const container = summary.querySelector('[data-tale-pdp-color-products]');
    const current = parseTitle(container?.dataset.productTitle || '');
    if (!container || !current || container.dataset.loaded === 'true') return;

    try {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const response = await fetch(`${root}collections/all/products.json?limit=250`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`TALE PDP catalog request failed: ${response.status}`);
      const products = (await response.json()).products || [];
      const siblings = products.map((item) => ({ item, parsed: parseTitle(item.title || '') }))
        .filter(({ item, parsed }) => item.handle && parsed?.modelKey === current.modelKey)
        .sort((a, b) => a.item.handle === container.dataset.currentHandle ? -1 : b.item.handle === container.dataset.currentHandle ? 1 : a.parsed.color.localeCompare(b.parsed.color, 'tr'));
      if (!siblings.length) return;

      const fragment = document.createDocumentFragment();
      siblings.forEach(({ item, parsed }) => {
        const colorKey = slugify(parsed.color);
        const link = document.createElement('a');
        link.className = 'tale-product-siblings__swatch';
        link.href = `${root}products/${item.handle}`;
        link.title = parsed.color;
        link.dataset.color = colorKey;
        link.setAttribute('aria-label', `${parsed.model}, ${parsed.color}`);
        link.style.setProperty('--tale-product-swatch', palette[colorKey] || '#b6b0a5');
        link.innerHTML = '<span aria-hidden="true"></span>';
        if (item.handle === container.dataset.currentHandle) {
          link.classList.add('is-current');
          link.setAttribute('aria-current', 'page');
        }
        fragment.append(link);
      });
      container.replaceChildren(fragment);
      container.dataset.loaded = 'true';
      const count = summary.querySelector('[data-tale-pdp-color-count]');
      if (count) count.textContent = `${siblings.length} renk`;
    } catch (error) { console.warn(error); }
  };

  const syncFirstFoldHeight = (mainProduct) => {
    if (!mainProduct || mainProduct.dataset.taleHeightReady === 'true') return;
    const mediaWrapper = mainProduct.querySelector('.product-grid__item--media-wrapper');
    const contentWrapper = mainProduct.querySelector('.product-grid__item--content-wrapper');
    if (!mediaWrapper || !contentWrapper) return;
    mainProduct.dataset.taleHeightReady = 'true';

    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          mediaWrapper.style.setProperty('--tale-pdp-first-fold-height', `${Math.ceil(contentWrapper.getBoundingClientRect().height)}px`);
          mediaWrapper.querySelectorAll('.swiper').forEach((slider) => slider.swiper?.update?.());
        } else {
          mediaWrapper.style.removeProperty('--tale-pdp-first-fold-height');
        }
      });
    };
    const observer = new ResizeObserver(update);
    observer.observe(contentWrapper);
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const mountLooxReviews = () => {
    const mount = document.querySelector('[data-tale-loox-mount]');
    const widget = document.querySelector('#looxReviews');
    const sourceSection = widget?.closest('.shopify-section');
    if (!mount || !widget || !sourceSection || mount.contains(sourceSection)) return Boolean(mount?.contains(sourceSection));

    mount.replaceChildren(sourceSection);
    mount.dataset.looxMounted = 'true';
    sourceSection.classList.add('tale-pdp-loox-source--mounted');
    window.dispatchEvent(new Event('resize'));
    return true;
  };

  const watchForLooxReviews = () => {
    const mount = document.querySelector('[data-tale-loox-mount]');
    if (!mount || mount.dataset.looxWatching === 'true' || mountLooxReviews()) return;
    mount.dataset.looxWatching = 'true';

    const observer = new MutationObserver(() => {
      if (mountLooxReviews()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 20000);
  };

  const init = (scope = document) => {
    watchForLooxReviews();
    scope.querySelectorAll('.main-product').forEach(syncFirstFoldHeight);
    scope.querySelectorAll('[data-tale-pdp-summary]').forEach((summary) => {
      hydrateColors(summary);

      const favorite = summary.querySelector('[data-tale-pdp-favorite]');
      if (favorite && favorite.dataset.ready !== 'true') {
        favorite.dataset.ready = 'true';
        const key = 'tale:pdp-favorites';
        const handle = favorite.dataset.productHandle;
        const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
        const render = () => {
          const active = read().includes(handle);
          favorite.classList.toggle('is-active', active);
          favorite.setAttribute('aria-pressed', String(active));
          favorite.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
        };
        favorite.addEventListener('click', () => {
          const items = read();
          localStorage.setItem(key, JSON.stringify(items.includes(handle) ? items.filter((item) => item !== handle) : [...items, handle]));
          render();
        });
        render();
      }

      summary.querySelector('[data-tale-installments-link]')?.addEventListener('click', (event) => {
        const link = event.currentTarget;
        const target = document.querySelector(link.getAttribute('href'));
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.history.replaceState(null, '', link.getAttribute('href'));
          return;
        }

        const trigger = document.querySelector('.tale-paytr-accordion__button');
        if (!trigger) return;
        event.preventDefault();
        if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
        trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
